import React  from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { REDIRECT_URL_KEY } from 'configs/AppConfig';

const PublicRoute = () => {

	const { token } = useSelector(state => state.auth)
	const [searchParams] = useSearchParams();
	const redirectUrl = searchParams.get(REDIRECT_URL_KEY);

	if (token) {
		const targetUrl = redirectUrl || "/";
		return <Navigate to={targetUrl} replace />;
	}

	return <Outlet />;
}

export default PublicRoute
